import React from "react";
import styled from "styled-components";
import { useWindowSize } from "@src/utils/useWindowSize";
import GridGuide from "./GridGuide";
import RemBasedFrame from "./RemBasedFrame";
import settings from "@src/settings";

interface Props {}

const Frame = styled.div`
	${RemBasedFrame} {
		pointer-events: none;
	}
`;
const BaseGrid: React.FC<Props> = (props) => {
	const { width: windowW } = useWindowSize();
	return (
		<Frame>
			<RemBasedFrame>
				<GridGuide
					fontSize={settings.baseGrid.fontSize}
					lineGap={settings.baseGrid.lineGap}
					columns={
						!windowW || windowW >= settings.breakpoint.xxl
							? {
									contentWidth: settings.contentWidth.xxl,
									count: 12,
									gutter: 16,
							  }
							: windowW >= settings.breakpoint.xl
							? {
									contentWidth: settings.contentWidth.xl,
									count: 10,
									gutter: 16,
							  }
							: windowW >= settings.breakpoint.lg
							? {
									contentWidth: settings.contentWidth.lg,
									count: 8,
									gutter: 16,
							  }
							: windowW >= settings.breakpoint.md
							? {
									contentWidth: settings.contentWidth.md,
									count: 6,
									gutter: 16,
							  }
							: windowW >= settings.breakpoint.sm
							? {
									contentWidth: settings.contentWidth.sm,
									count: 6,
									gutter: 16,
							  }
							: {
									contentWidth:
										(Math.floor(windowW / settings.baseGrid.fontSize) - 2) *
										settings.baseGrid.fontSize,
									count: 1,
									gutter: 16,
							  }
					}
				/>
			</RemBasedFrame>
		</Frame>
	);
};

export default BaseGrid;
